import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const GetAllLandlordMaintenanceRequest = createAsyncThunk(
    "dummyData/landlordMaintenanceRequest",
    async ({ userId }) => {
        let response = await axios.get(`${BASE_URL}/get-all-maintenance-request/${userId}`);
        return response?.data; // <-- Best practice: return only data
    }
);

const GetMaintenanceAll = createSlice({
    name: "landlordMaintenanceRequest",
    initialState: {
        loading: false,
        GetMaintenanceAll: [],
        error: ""
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllLandlordMaintenanceRequest.pending, (state) => {
                state.loading = true;
            })
            .addCase(GetAllLandlordMaintenanceRequest.fulfilled, (state, action) => {
                state.loading = false;
                state.GetMaintenanceAll = action.payload;
            })
            .addCase(GetAllLandlordMaintenanceRequest.rejected, (state, action) => {
                state.loading = false;     // <-- FIX
                state.error = action.error.message;
            });
    },
});

export default GetMaintenanceAll.reducer;
